export { default } from './BlogView'
